import axiosInstance  from "services/axiosMiddleware";

export async function createRelaxation(relaxationData) {
    try {
        const response = await axiosInstance.post("/relaxation/createRelaxation",relaxationData)
        return response.data
    } catch (error) {
        console.error(error);
        throw error
    }
    
}